/**
 * cart-confetti.js
 * Lightweight canvas confetti (Optimized)
 */

class CartConfetti {
  constructor(options = {}) {
    this.options = {
      particleCount: 60,
      gravity: 0.25,
      drag: 0.985,
      zIndex: 9999,
      colors: [
        "#ff3b30",
        "#ff9500",
        "#ffcc00",
        "#34c759",
        "#007aff",
        "#5856d6",
        "#ff2d55",
      ],
      ...options,
    };

    this.particles = [];
    this.raf = null;

    this.createCanvas();
    this.resize();

    this.animate = this.animate.bind(this);

    window.addEventListener("resize", () => this.resize());
  }

  createCanvas() {
    this.canvas = document.createElement("canvas");

    Object.assign(this.canvas.style, {
      position: "fixed",
      inset: "0",
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      zIndex: this.options.zIndex,
    });

    document.body.appendChild(this.canvas);

    this.ctx = this.canvas.getContext("2d");
  }

  resize() {
    const dpr = window.devicePixelRatio || 1;

    this.canvas.width = window.innerWidth * dpr;
    this.canvas.height = window.innerHeight * dpr;

    this.canvas.style.width = window.innerWidth + "px";
    this.canvas.style.height = window.innerHeight + "px";

    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  createParticle(x, y) {
    const ribbon = Math.random() > 0.5;

    return {
      x,
      y,

      vx: (Math.random() - 0.5) * 14,
      vy: -10 - Math.random() * 10,

      gravity: this.options.gravity,
      drag: this.options.drag,

      rotation: Math.random() * Math.PI * 2,
      spin: (Math.random() - 0.5) * 0.25,

      color:
        this.options.colors[
          Math.floor(Math.random() * this.options.colors.length)
        ],

      ribbon,

      width: 3 + Math.random() * 2,
      height: 10 + Math.random() * 8,

      radius: 2 + Math.random() * 2,
    };
  }

  fire({
    x = this.canvas.width / (2 * (window.devicePixelRatio || 1)),
    y = this.canvas.height / (2 * (window.devicePixelRatio || 1)),
    particleCount = this.options.particleCount,
  } = {}) {
    for (let i = 0; i < particleCount; i++) {
      this.particles.push(this.createParticle(x, y));
    }

    if (!this.raf) {
      this.animate();
    }
  }

  updateParticle(p) {
    p.vx *= p.drag;
    p.vy *= p.drag;

    p.x += p.vx;
    p.y += p.vy;

    p.vy += p.gravity;
    p.rotation += p.spin;
  }

  drawParticle(p) {
    const ctx = this.ctx;

    ctx.save();

    ctx.translate(p.x, p.y);
    ctx.rotate(p.rotation);

    ctx.fillStyle = p.color;

    if (p.ribbon) {
      // Smooth ribbon flip
      ctx.scale(0.3 + Math.abs(Math.cos(p.rotation)) * 0.7, 1);

      ctx.fillRect(
        -p.width / 2,
        -p.height / 2,
        p.width,
        p.height
      );
    } else {
      ctx.beginPath();
      ctx.arc(0, 0, p.radius, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.restore();
  }

  animate() {
    this.ctx.clearRect(
      0,
      0,
      this.canvas.width,
      this.canvas.height
    );

    const alive = [];

    for (const p of this.particles) {
      this.updateParticle(p);
      this.drawParticle(p);

      if (
        p.y <= window.innerHeight + 100 &&
        p.x >= -100 &&
        p.x <= window.innerWidth + 100
      ) {
        alive.push(p);
      }
    }

    this.particles = alive;

    if (this.particles.length) {
      this.raf = requestAnimationFrame(this.animate);
    } else {
      cancelAnimationFrame(this.raf);
      this.raf = null;
    }
  }

  burst(options = {}) {
    this.fire(options);
  }

  destroy() {
    if (this.raf) {
      cancelAnimationFrame(this.raf);
    }

    this.raf = null;
    this.particles = [];

    if (this.canvas) {
      this.canvas.remove();
    }
  }
}

window.CartConfetti = new CartConfetti();